// extracted by mini-css-extract-plugin
export default {"label":"PhoneNumberInput_label__UO50N","buttonWrapper":"PhoneNumberInput_buttonWrapper__EFpY6"};